import { ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";

import { useUserStore } from "@stores/index";
import {
  DashboardSvg,
  CreditCardPaySvg,
  LicenseSvg,
  Briefcase2Svg,
  MapPinSvg,
  SquarePercentageSvg,
  MessageCircleSvg,
} from "@components/index";

export const NavPanelMobile = () => {
  const location = useLocation();
  const currentPage = location.pathname;
  const puEnabled = useUserStore(({ puEnabled }) => puEnabled);
  const disabledFeatures = useUserStore(
    ({ disabledFeatures }) => disabledFeatures,
  );
  const businesses = useUserStore(({ businesses }) => businesses);

  const items: {
    to: string;
    label: string;
    testId: string;
    image: ReactNode;
  }[] = [
    {
      to: "/",
      label: "Dashboard",
      testId: "navigation_dashboard",
      image: <DashboardSvg />,
    },
    {
      to: "/transactions",
      label: "Transactions",
      testId: "navigation_transactions",
      image: <CreditCardPaySvg />,
    },
    {
      to: "/assets",
      label: "Assets",
      testId: "navigation_assets",
      image: <Briefcase2Svg />,
    },
    {
      to: "/submissions",
      label: "Submissions",
      testId: "navigation_submissions",
      image: <LicenseSvg />,
    },
    {
      to: "/privateUse",
      label: "Private Use",
      testId: "navigation_privateUse",
      image: <SquarePercentageSvg />,
    },
    {
      to: "/mileage",
      label: "Mileage Log",
      testId: "navigation_mileage",
      image: <MapPinSvg />,
    },
    {
      to: "/queries",
      label: "Queries",
      testId: "navigation_queries",
      image: <MessageCircleSvg />,
    },
  ]
    .filter(
      ({ label }) =>
        (puEnabled &&
          !disabledFeatures.includes("Private Use") &&
          businesses.find((b) => b.type !== "landlord")) ||
        label !== "Private Use",
    )
    .filter(
      ({ label }) => !disabledFeatures.includes("Assets") || label !== "Assets",
    )
    .filter(
      ({ label }) =>
        !disabledFeatures.includes("Mileage Log") || label !== "Mileage Log",
    );

  return (
    <div className="fixed bottom-0 flex h-[50px] w-full items-center justify-between border-t border-black-16 bg-white-100">
      {items.map(({ to, label, testId, image }) => (
        <Link
          key={to}
          to={to}
          data-testid={testId}
          className={twMerge(
            clsx(
              "block w-20 font-light text-black-54 hover:font-bold hover:text-primary-300",
              (to !== "/" ? currentPage.includes(to) : to === currentPage) &&
                "font-bold text-primary-300",
            ),
          )}
        >
          <div className="flex justify-center">{image}</div>
          <div className="mt-1 text-center text-90">{label}</div>
        </Link>
      ))}
    </div>
  );
};
